import { render, staticRenderFns } from "./EditCategoryPage.vue?vue&type=template&id=7ec08557&"
import script from "./EditCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryPage.vue?vue&type=style&index=0&id=7ec08557&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports